import { render } from "./institutionDetails.vue?vue&type=template&id=bdd0c2da"
import script from "./institutionDetails.vue?vue&type=script&lang=js"
export * from "./institutionDetails.vue?vue&type=script&lang=js"

import "./institutionDetails.vue?vue&type=style&index=0&id=bdd0c2da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__